import React, { useState } from 'react';
import { Nav, Navbar, Dropdown } from 'react-bootstrap';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'
import { clearUserData, toggleConnectedUsersBar } from './../../Redux/actions';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';

import UserModal from './UserModal';

const MainHeader = props =>{
    const [ showModal, setShowModal ] = useState(false)
    const history = useHistory();

    const user = useSelector(store=>store.user);
    const connectedBarShow = useSelector(store=>store.ui.connectedUsersBarShow);
    const dispatch = useDispatch();

    const logout = () =>{
        dispatch(clearUserData());
        axios.get('/logout');
        history.push('/login')
    }

    const toggleExternalBar = () =>{
        dispatch(toggleConnectedUsersBar())
    }

    return (
        <Navbar bg='dark' className='d-flex pl-3 pr-0 py-0 text-white shadow font12 align-items-center'>
            <Navbar.Brand href='/' className='text-white font-weight-bolder '>
                <img 
                    src={require('./../../images/logo.png').default} 
                    width={33} 
                    alt='x' 
                    className='mr-1 my-1' 
                />
                    <span className='font15 d-none d-md-inline'>e1maxChat</span>
            </Navbar.Brand>
            
            <Nav className='justify-content-end w-100 align-items-center'>
                {
                    user?.rolX && 
                        <Nav.Item>
                            <Nav.Link className='d-flex' onClick={()=>history.push('/main/settings')}>
                                <span className='material-icons text-white' style={{fontSize:21}}>settings</span>
                            </Nav.Link>
                        </Nav.Item>
                }
                <Nav.Item onClick={toggleExternalBar}>
                    <Nav.Link className='text-white mr-2' >
                        <p className={classnames('my-auto', {'font-weight-bold' : connectedBarShow })}>Users[{props.users.length}]</p>
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item className='mr-3 mt-1'>
                    <Dropdown className='p-0 m-0'>
                        <Dropdown.Toggle variant='dark' id="dropdown-basic" menualign={{lg:'left'}} className='p-0 m-0' style={{fontSize:13}}>
                            {
                                user?.avatar !=='' && <img className='rounded-circle mr-2' src={require(`./../../avatars/${user?.avatar?? 0}.png`).default} width={35} alt='av'/>
                            }
                            {user?.name}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className='px-0  mt-1' style={{fontSize: 13}} align='right'>
                            <Dropdown.Item  className='py-2 'onClick={()=>{setShowModal(true)}}>Edit User</Dropdown.Item>
                            <Dropdown.Item className='text-danger py-2' onClick={logout}>Sign out</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Nav.Item>
            </Nav>
            <UserModal show ={showModal} handleShow={()=>setShowModal(!showModal)} user={user} socket={props.socket}/>
        </Navbar>
    )
}

export default MainHeader;